import { AutoForecastReviewResponse } from "../interfaces/auto-forecast.interface";
import { format } from "date-fns";

export const DialogMessageUtility = (action: "Delete" | "Enable" | "Disable" | "Remove" | "Clear All", provider: string = '') => {
    const actionLower = action.toLowerCase();
    return {
        title: `${action} ${provider}`,
        message: `Are you sure you want to ${actionLower} this ${provider}?`,
        buttonText: action,
    };
};

export const DialogMessageSaveConfirmation = (effectiveDate: string) => {
  return {
    title: `Save Payor Configuration`,
    message: `The changes you’ve made will take effect for facility's payors on <strong>${effectiveDate}</strong>.`,
    buttonText: "Save",
  };
};

export const facilityCanNotDelete = (facilityname: string) => (`This <b>${facilityname}</b> cannot be deleted due to the presence of patient records and data.`)

export const DialogMessageReviewUtility = (
    action: "Review",
    provider: string = '',
    reviewresponse: AutoForecastReviewResponse
  ) => {
    let message = '';
  
    reviewresponse.alertsByDiscipline.forEach((discipline) => {
      let disciplineName = '';
  
      if (discipline.disciplineId === 1) {
        disciplineName = '<strong style="display: block; text-align: left;">PT</strong>';
      } else if (discipline.disciplineId === 2) {
        disciplineName = '<strong style="display: block; text-align: left;">OT</strong>';
      } else if (discipline.disciplineId === 3) {
        disciplineName = '<strong style="display: block; text-align: left;">ST</strong>';
      }
  
      let messages: string[] = [];
  
      if (discipline.existingDataOverlapAlert?.lastForecastDate) {
        messages.push(
          `<div style="text-align: left;">Your auto-forecast overlaps with existing data. Last forecast ended on <strong>${discipline.existingDataOverlapAlert.lastForecastDate}</strong>.</div>`
        );
      }
      if (discipline.durationAlert?.weeksToOverrideExistingData) {
        messages.push(
          `<div style="text-align: left;">Your auto-forecast should be <strong>${discipline.durationAlert.weeksToOverrideExistingData}</strong> weeks to overwrite all previous data.</div>`
        );
      }
  
      // Append messages if they exist
      if (messages.length > 0) {
        message += `<div style="font-weight: bold; margin-top: 10px;">${disciplineName}</div>
                        <ul style="list-style: disc !important; padding-left: 20px;">`
        
        messages.forEach(msg=>{
            message += `<li>${msg}</li>`;
        })
        message += ` </ul>`;
      }
    });
    console.log(message);
    
    return {
      title: `${action} ${provider}`,
      message: message,
      buttonText: 'Overwrite',
    };
  };
  
  
export const DateFormat = "MM/dd/yyyy";
export const ISODateFormat = "yyyy-MM-dd";

export const functionString = "function";

export const DashDateFormat = "MM-dd-yyyy";

export const DefaultTimeZone = "US/Eastern";

export const ISODateSeparator = 'T';

/** Midnight, for pinning a date-only value to the start of its day in an ISO string. */
export const StartOfDayTime = '00:00:00';

export const DateSeparator = '//';

export const Blank = '_blank';

export const DefaultLocale = 'en-US';

export const DateQueryParam = "date";

export const ErrorString = "Error";

export const Ok = "OK";

export const FacilityListLength = 500000;

export const FacilityNameField = "name";

export const ReviewRequiredMessage = "Would you like to continue without making changes?  Otherwise, click Cancel and make the appropriate change";

export const MandatoryFieldsErrorMessage = "Mandatory fields are not filled";

export const CorporationDialogDeleteNote = "Once deleted this Corporation will no longer have access to Rehab Connect";

export const CorporationDialogDisableNote = "Once disabled this Corporation will no longer have access to Rehab Connect";

export const CorporationDialogEnableNote = "Once enabled this Corporation will have access to Rehab Connect";

export const FacilityDialogDeleteNote = "Once deleted this Facility will no longer have access to Rehab Connect";
export const FacilityNotAssignedTooltip = "You are not assigned to this facility.";
export const FacilityInactiveTooltip = "This facility is not active.";

export const FacilityDialogDisableNote = "Once disabled this Facility will no longer have access to Rehab Connect";

export const FacilityDialogEnableNote = "Once enabled this Facility will have access to Rehab Connect";

export const FacilityAdmissionDialogDeleteNote = "Once deleted this Facility will no longer have access to Rehab Connect";

export const TeraphyEpisodeDialogDeleteNote = "Once deleted this Therapy Episode will no longer be available in Rehab Connect";

export const UserDialogDeleteNote = "Once deleted this User will no longer have access to Rehab Connect";

export const UserDialogDisableNote = "Once disabled this User will no longer have access to Rehab Connect";

export const UserDialogEnableNote = "Once enabled this User will have access to Rehab Connect";

export const SelectSaveAlert = "* Must select Save to add to group";

export const FetchGroupError = "Error fetching group details";

export const confirmSyncPatientData = "Are you sure you would like to sync this patient's data to the forecast?";

export const CorporationsListDescription = "The corporations listed below have been added to Rehab Connect. To add more corporations, click ‘Add Corporation’. To access a corporation’s profile, click the name link.";

export const FacilityListDescription = "The facilities listed below have been added to Rehab Connect.  To access a facility’s profile, click the name link.";

export const PayorInUseMessage = "The payor plan selected cannot be set to Inactive. It is currently in use by the facilities and patients listed below. ";

export const NotClockedOutPreviousDayError = "You have not clocked out for a previous day.  Please click the link below to correct your time card.";

export const ClockOutBeforeClockInError = "Clock out time cannot be before Clock in time";

export const ClockInOutAfterCurrentTimeError = "Clock in/out cannot be after the current time";

export const PasswordHasBeenResetMessage = "Your password has been reset. You will now be directed to the login page.";

export const PasswordResetInvalidMessage = "The password reset link is invalid or has expired.";

export const PatientsAddedToInTheraphy = "The patients listed below have been added to Rehab Connect.  To access patient’s profile, click the name link."

export const FileUploadingErrorMessage = "An error occurred while uploading the file.";

export const ErrorWhileSavingMessage = "An error occurred while saving your changes";

export const SomethingWentWrong = "Something went wrong";


export function getLastTxDateRangeError(min: Date, max: Date): string {
  return `The date must be between ${format(min, DateFormat)} and ${format(max, DateFormat)} therapy episode date`;
}

export const EmptyData = "--";

export const UpdateActivityUrl = "patientdocumentation/update-activity-date"

export const PUT = "PUT";

export const DateError= "The date must be after the latest therapy episode date:";

export const ConfirmCancellation = {
    title: "Confirm Cancellation",
    message: "You have indicated you would like to cancel your actions.  Please let us know if you would like to save your changes before continuing or cancel without saving.",
    buttonText: "Save & Continue",
    cancelText: "Cancel without Saving"
}

export const ChangesSaved = {
    title: "Changes Saved",
    message: "Your changes have been saved",
    buttonText: "Ok",
    hideCancelButton: true
}

export const Success = (message : string = "Saved Successfully") => {
  return{ 
      title: "Saved",
      message: message,
      buttonText: "Ok",
      hideCancelButton: true
    }
} 

export const SecurityGroupMessages = {
    copy: {
        title: "Copy Group",
        message: "Would you like to Copy this Group?",
        buttonText: "Copy",
    }
}

export const SetUpSettingsConfigurationData = {
    header: 'Signature PIN',
    instructions: 'A PIN will be required when you sign your documents. Please select a 6-digit PIN below.',
    saveButtonText: 'Continue'
}

export const ESignatureSettingsConfiguration = {
    header: 'Change PIN',
    instructions: 'A new is PIN will be required when you want to change your old pin. Please select a New 6-digit PIN below.',
    saveButtonText: 'Save'
}

export const ContractFinalizedData = {
    title: "Contract Finalized",
    message: "Your contract has been finalized",
    hideCancelButton: true,
    buttonText: "Ok",
}

export const PatientNotesSavingData = {
    title: "Success",
    message: "The notes have been saved successfully.",
    buttonText: "Continue",
    hideCancelButton: true,
}

export const CancelAndExit = {
    title: "Confirm Cancel",
    message: "You have chosen to cancel and exit this process.",
    buttonText: "Continue",
}

export const BillingEntryError = {
    title: "Billing Entry Error",
    message:
        "The total of Co-Treatment and Concurrent minutes is greater than the total billed. Please update your billing to accurately reflect services rendered.",
    buttonText: "OK",
    hideCancelButton: true,
    isError: true,
}

export const Attestation = {
    title: "Attestation",
    message:
        "I agree that the information submitted on this screen was performed by myself, meets all applicable federal and state guidelines, care was provided within the scope of my professional practice act, and is accurate to the skilled care provided.<br/><br/>I understand that by signing this document with my digital signature is the legal equivalent of placing my handwritten signature on this document and that is my intent.<br/><br/>I understand that I am placing my digital signature on this document which is equivalent to placing my handwritten signature and that all information is accurate. I agree with this statement and I agree to applying my digital signature to this submitted information and documentation.",
    buttonText: "Save",
}

export const ResendInvite = {
    title: "Resend Invite",
    message: "Would you like to resend the user their invite?",
    buttonText: "Resend Invite",
}

export const ResetPassword = {
    title: "Reset Password",
    message: "Would you like to reset this User's password?",
    buttonText: "Reset Password",
}

export const InvalidEntry ={
    //user should be allowed to enter the < symbol
    title: "Invalid Characters",
    message: "The text contains an invalid character ('<'). Please remove it and try again.",
    buttonText: "Ok",
    hideCancelButton: true,
    isError:true
}

export const Identifications = {
  facilityId: "facilityId",
  therapyId: "therapyId",
  patientDocumentId: "patientDocumentId",
}

export const CompletedDCConfirmation ={
    title: "Completed DC Document Already Exists on that Date",
    message: "Discharge document is Already in the Completed state, If Billing is deleted the Discharge document will be moved to Initiated State. Are you sure you want to continue?",
    buttonText: "Continue",
}

export const RefetchConfirmation = {
  title: "Potential Data loss",
  message: "There is data present in the Document by choosing to continue, the current data will be discarded and information will be fetched from Previous completed Document, are you sure to continue?",
  buttonText: "Confirm",
  cancelText: "Cancel"
}

export const SourceDocumentDeletion = (message: string) => {
  return {
    message: message,
    hideCancelButton: true,
    isError: false,
    buttonText: 'Ok'
  }
}